import { styled } from '@mui/system';
import { Button, Box } from '@mui/material';

export const ModalOverlay = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(6px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: theme.zIndex.modal,
    padding: theme.spacing(2),
}));

export const ModalCard = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(3),
    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25), 0 12px 24px rgba(0, 0, 0, 0.15)',
    border: `1px solid ${theme.palette.divider}`,
    maxWidth: '480px',
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #1976d2, #42a5f5, #1976d2)',
        borderRadius: `${theme.spacing(3)} ${theme.spacing(3)} 0 0`,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: theme.spacing(3),
        boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.1)',
        pointerEvents: 'none',
    }
}));

export const ModalContent = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    textAlign: 'center',

    '& h2': {
        fontWeight: 600,
        color: theme.palette.text.primary,
        margin: 0,
    },
}));

export const ModalActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2.5),

    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
}));

export const StyledButton = styled(Button)(({ isCancel = false, theme }) => ({
    flex: 1,
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(2),
    fontWeight: 500,
    fontSize: '1rem',
    textTransform: 'none',
    border: `2px solid ${isCancel ? theme.palette.grey[500] : theme.palette.primary.main}`,
    backgroundColor: isCancel ? theme.palette.grey[50] : theme.palette.primary.main,
    color: isCancel ? theme.palette.text.secondary : theme.palette.primary.contrastText,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',

    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-100%',
        width: '100%',
        height: '100%',
        background: isCancel
            ? `linear-gradient(90deg, transparent, ${theme.palette.grey[300]}, transparent)`
            : `linear-gradient(90deg, transparent, ${theme.palette.primary.light}, transparent)`,
        transition: 'left 0.5s ease',
    },

    '&:hover': {
        backgroundColor: isCancel ? theme.palette.grey[300] : theme.palette.primary.dark,
        color: isCancel ? theme.palette.text.primary : theme.palette.primary.contrastText,
        transform: 'translateY(-2px)',
        boxShadow: isCancel
            ? `0 8px 25px ${theme.palette.grey[500]}40`
            : `0 8px 25px ${theme.palette.primary.main}40`,
        borderColor: isCancel ? theme.palette.grey[600] : theme.palette.primary.dark,

        '&::before': {
            left: '100%',
        }
    },

    '&:active': {
        transform: 'translateY(0)',
        transition: 'all 0.1s ease',
    },

    '&:focus': {
        outline: 'none',
        boxShadow: `0 0 0 4px ${isCancel ? theme.palette.grey[500] : theme.palette.primary.main}30`,
    },

    '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed',
        transform: 'none',
    },
}));
